import { render, staticRenderFns } from "./MedicineAdmin.vue?vue&type=template&id=889d1456&scoped=true"
import script from "./MedicineAdmin.vue?vue&type=script&lang=js"
export * from "./MedicineAdmin.vue?vue&type=script&lang=js"
import style0 from "./MedicineAdmin.vue?vue&type=style&index=0&id=889d1456&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889d1456",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('889d1456')) {
      api.createRecord('889d1456', component.options)
    } else {
      api.reload('889d1456', component.options)
    }
    module.hot.accept("./MedicineAdmin.vue?vue&type=template&id=889d1456&scoped=true", function () {
      api.rerender('889d1456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/MedicineAdmin.vue"
export default component.exports